// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__NpR-e","modalBody":"MealsPop_modalBody__qwhz9"};